import * as React from 'react';

// components
import Login from 'modules/login';
import BaseScreen from '../../modules/base-screen';

const LoginScreen: React.FC = () => {
    return (
        <BaseScreen>
            <Login alwaysConfirmAccount={false}/>
        </BaseScreen>
    );
};

export default LoginScreen;
